module.exports = __webpack_public_path__ + "static/media/ImageMusic_elBanner982162_1920_675034.bef1d5a2.jpg";